import { supabase } from './client';
import { DBUserSubscription } from './types';
import { PlanId, DEFAULT_PLAN_ID } from '../../config/plans';
import { createLogger } from '../logger';

const log = createLogger('subscription');

export const subscriptionService = {
  async getSubscription(userId: string): Promise<DBUserSubscription | null> {
    const { data, error } = await supabase
      .from('user_subscriptions')
      .select('*')
      .eq('user_id', userId)
      .single();

    if (error) {
      if (error.code === 'PGRST116') return null;
      log.error('Failed to fetch subscription:', error);
      return null;
    }

    return data;
  },

  async getEffectivePlanId(userId: string): Promise<PlanId> {
    const sub = await this.getSubscription(userId);
    if (!sub) return DEFAULT_PLAN_ID;

    if (sub.status !== 'active') return DEFAULT_PLAN_ID;

    if (sub.expires_at && new Date(sub.expires_at) < new Date()) {
      return DEFAULT_PLAN_ID;
    }

    const validPlans: PlanId[] = ['free', 'plus', 'premium'];
    if (validPlans.includes(sub.plan_id as PlanId)) {
      return sub.plan_id as PlanId;
    }

    return DEFAULT_PLAN_ID;
  },
};
